import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Transition() {
  return <section className="bg-brand-beige py-20 px-6" data-id="element-770">
      <div className="max-w-3xl mx-auto text-center" data-id="element-771">
        <FadeIn data-id="element-772">
          {/* Título principal */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-6 leading-tight" data-id="element-773">
            NO TODOS COMIENZAN CON AMAZON FBA…
            <br data-id="element-774" />
            <span className="text-brand-green/80" data-id="element-775">Y ESO ESTÁ BIEN.</span>
          </h2>

          {/* Texto secundario */}
          <p className="text-lg md:text-xl text-brand-text/70 mb-10 leading-relaxed" data-id="element-776">
            Existe una forma MÁS SIMPLE de comenzar a vender en Amazon, con
            menor inversión y mayor control desde el primer día.
          </p>

          {/* Título destacado */}
          <div className="bg-white border border-brand-green/10 rounded-2xl px-6 py-8 md:px-10 md:py-10 mb-10 shadow-sm" data-id="element-777">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-gold mb-3" data-id="element-778">
              ⚡ La alternativa práctica
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-brand-green mb-6" data-id="element-779">
              APRENDE A VENDER CON AMAZON FBM
            </h3>

            {/* Texto persuasivo */}
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-780">
              Con Amazon FBM puedes comenzar desde casa sin necesidad de enviar
              inventario a bodegas FBA.
            </p>
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-781">
              Tendrás el control de tus productos, tus envíos y tus ventas
              mientras aprendes paso a paso cómo funciona realmente Amazon.
            </p>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed italic" data-id="element-782">
              Ideal para personas que quieren empezar con una inversión más
              baja, menos complicaciones y una forma más práctica de generar
              ingresos online.
            </p>
          </div>

          {/* Texto de refuerzo - bullets */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10 text-left" data-id="element-783">
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-784">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-785" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-786">
                Menor inversión inicial
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-787">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-788" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-789">
                Más control sobre tus productos
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-790">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-791" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-792">
                Aprende desde cero paso a paso
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-793">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-794" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-795">
                Empieza desde casa incluso si eres principiante
              </span>
            </div>
          </div>

          {/* Frase final */}
          <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold leading-relaxed" data-id="element-796">
            Amazon FBM puede ser el primer paso que necesitabas para comenzar tu
            negocio online.
          </p>
        </FadeIn>
      </div>
    </section>;
}